import { User } from 'store/user/types';
import { hasPermissions } from 'store/user/utils/has-permissions.util';

export const ADMIN_PANEL_ACCESS_PERMISSION_NAME = 'hqo-admin-panel-access';

export const hasAccessPermissions = (user: Pick<User, 'roles'>): boolean =>
  hasPermissions(user, ADMIN_PANEL_ACCESS_PERMISSION_NAME);
